import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { EventsStore } from "../domain/events-model";
export const updateEvent = createAsyncThunk<void, any>("event/updateEvents",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<any>>(`${AppConstants.api}/event`, payload)
})
export const fetchEventsList = createAsyncThunk<
  any[],
  { projectId: string; type: string }
>("event/fetchEventsList", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/event`;
  const response = await api.get<ApplicationResponse<any[]>>(url, {
    params: {
      projectId,
      projectType: type.toUpperCase(),
    },
  });
  return response.data.data || [];
});

const EventsSlice = createSlice({
  name: "events",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as EventsStore,
  reducers: {
    resetEvents: (state) => {
      state.minimal = {
        status: "loading",
        error: null,
        data: [],
      };
    },
     updateEvents: (state, action: PayloadAction<any>) => {
      state.minimal.data = state.minimal.data.map(event => 
        event.id === action.payload.id ? action.payload : event
      );
    },
    addEvents: (state, action) => {
      state.minimal.data.push(action.payload);
    },
    removeEvent: (state, action) => {
      state.minimal.data = state.minimal.data.filter(
        (event: any) => event.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventsList.pending, (state) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchEventsList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchEventsList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});
export const { removeEvent, updateEvents,addEvents, resetEvents } = EventsSlice.actions;

export default EventsSlice.reducer;
